var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGameLoss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_85976",
    "data-name": "Group 85976",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.744,
    height: 12.236,
    viewBox: "0 0 10.744 12.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-trophy-1807154",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125233",
    "data-name": "Path 125233",
    d: "M13.189,2.477c-.052-.925-.506-1-.644-1H10.967c0-.01,0-.021,0-.03C11.026.62,10.792.5,10.228.5H5.417c-.564,0-.8.119-.741.949,0,.009,0,.02,0,.03H3.1c-.138,0-.592.072-.644,1-.089,1.6,1.074,4.251,4.518,4.846.04.024.078.049.12.071a.5.5,0,0,0,.324.889H7.5a4.145,4.145,0,0,1-1.528,2.95H7.583a.134.134,0,1,1,0,.268H5.248a.356.356,0,0,0-.276.346v.535a.356.356,0,0,0,.356.356h4.989a.356.356,0,0,0,.356-.356v-.535a.356.356,0,0,0-.356-.356h-.173a3.834,3.834,0,0,1-2-3.208h.085a.5.5,0,0,0,.324-.889c.041-.023.08-.047.12-.071C12.116,6.727,13.279,4.079,13.189,2.477Zm-2.267-.4H12.5a2.4,2.4,0,0,1-.089,1.646A4.409,4.409,0,0,1,9.575,6.481,9.223,9.223,0,0,0,10.923,2.074ZM3.235,3.72a2.4,2.4,0,0,1-.089-1.646H4.722A9.226,9.226,0,0,0,6.07,6.481,4.407,4.407,0,0,1,3.235,3.72Z",
    transform: "translate(-2.451 -0.501)",
    fill: "#5142fc"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_293",
    "data-name": "Ellipse 293",
    transform: "translate(3.072 0.911)",
    fill: "none",
    stroke: "#dcf8c5",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.3,
    cy: 2.3,
    r: 2.3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.3,
    cy: 2.3,
    r: 2.25,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "noun-poker-chip-17177",
    transform: "translate(3.435 1.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85920",
    "data-name": "Group 85920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125234",
    "data-name": "Path 125234",
    d: "M3.036,2.845A1.46,1.46,0,0,0,3.3,2.4l.4.231a1.921,1.921,0,0,0,0-1.454l-.4.231A1.46,1.46,0,0,0,3.036.958l.4-.231A1.916,1.916,0,0,0,2.178,0V.462a1.449,1.449,0,0,0-.517,0V0A1.917,1.917,0,0,0,.4.727L.8.958a1.461,1.461,0,0,0-.259.447l-.4-.231a1.921,1.921,0,0,0,0,1.454l.4-.231A1.459,1.459,0,0,0,.8,2.845l-.4.231A1.916,1.916,0,0,0,1.66,3.8V3.341a1.452,1.452,0,0,0,.517,0V3.8a1.916,1.916,0,0,0,1.259-.727ZM1.231.71A1.381,1.381,0,0,1,1.394.63l.05.086A1.275,1.275,0,0,0,1.131.9L1.081.811A1.382,1.382,0,0,1,1.231.71Zm-.4.353.086.05a1.274,1.274,0,0,0-.181.313l-.086-.05A1.375,1.375,0,0,1,.829,1.063Zm-.273.657h.1a1.267,1.267,0,0,0,0,.361h-.1A1.374,1.374,0,0,1,.556,1.721ZM.829,2.739a1.375,1.375,0,0,1-.181-.313l.086-.05a1.276,1.276,0,0,0,.181.313Zm.565.433a1.371,1.371,0,0,1-.313-.18l.05-.087a1.279,1.279,0,0,0,.313.181Zm.706.092a1.343,1.343,0,0,1-.361,0v-.1a1.264,1.264,0,0,0,.361,0ZM2.1.637a1.268,1.268,0,0,0-.361,0v-.1a1.343,1.343,0,0,1,.361,0ZM3.282,2.082h-.1a1.271,1.271,0,0,0,0-.361h.1A1.369,1.369,0,0,1,3.282,2.082ZM3.009,1.063a1.386,1.386,0,0,1,.181.313l-.086.05a1.277,1.277,0,0,0-.181-.313Zm-.4,2.029a1.4,1.4,0,0,1-.163.08l-.05-.086a1.28,1.28,0,0,0,.313-.181l.05.086A1.392,1.392,0,0,1,2.607,3.093Zm.1-2.2A1.273,1.273,0,0,0,2.395.716L2.444.63a1.375,1.375,0,0,1,.313.18ZM2.923,2.69A1.277,1.277,0,0,0,3.1,2.377l.086.05a1.376,1.376,0,0,1-.181.313Z",
    fill: "#dcf8c5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameLoss);
export default __webpack_public_path__ + "static/media/game-loss.5ffaac5f7e7cec160579aaf37d0ffaf1.svg";
export { ForwardRef as ReactComponent };